import { render, staticRenderFns } from "./OfficeAddress.vue?vue&type=template&id=4a29fb16&scoped=true"
import script from "./OfficeAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfficeAddress.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29fb16",
  null
  
)

export default component.exports